/* ==================================================================
   RGX OVERRIDES JS · all RIGNOX runtime patches live in this ONE file.
   Loaded from layout/theme.liquid (deferred). Never edit theme JS
   files directly — patch prototypes here after the element is defined.
   ================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     1. [REMOVED 2026-09-05] Cart drawer onCartUpdate no-op.
        This patch blanked cart-drawer-items.onCartUpdate to skip a
        "redundant" fetch. It was WRONG: in Force 1.1.3 the drawer
        (<cart-drawer-items> extends CartItems) refreshes its contents
        precisely by running onCartUpdate() when it receives the
        cartUpdate pub/sub event fired on add-to-cart (see assets/cart.js
        CartItems.connectedCallback -> onCartUpdate -> fetch
        /cart?section_id=main-cart-items). Blanking it meant the drawer
        never repainted, so it showed 0 items after adding — shoppers
        abandoned (confirmed by Shopify's shopping simulation, 2026-09-05).
        The method is left at its native behaviour. Do NOT re-add this.
     ---------------------------------------------------------------- */

  /* ----------------------------------------------------------------
     2. Contact page deep links.
        (a) ?topic=<key> pre-selects a topic and scrolls to the form, so
            any page or email can send the buyer straight to the right
            option: install | unshipped | address | vehicle | other
            (e.g. the install guides page links ?topic=install).
        (b) One-tap vehicle request from ?build=<Year Make Model>
            (+ optional &lights=Headlights|Tail lights), sent by
            sections/rgx-ymm.liquid when the vehicle selector has no
            match. Rule (Rachel, 2026-10-06): the buyer types NOTHING but
            their email — everything else is filled in and they just tap
            send.
          - Topic = "Vehicle not listed"
          - Vehicle = the build; message = a complete request starting
            with a fixed "Vehicle request:" line (searchable demand
            signal; was "Fitment request:" before 2026-10-06) plus a
            "Looking for:" line when the selector sat on a headlight or
            tail light collection
          - name / phone row and the message box are hidden (name is
            made optional); the request hint says only the email is left
          - the page scrolls to the form (the help cards sit above it)
        A signed-in customer's email is already filled by the theme, so
        for them it is a single tap. The theme's floating-label script
        may run before us, so we also set has-content / hide labels
        ourselves. §7 shows/requires the right fields on init.
        Promise in the copy (Rachel, 2026-10-06): we log every request,
        use it to plan new fitments, and email the buyer as soon as their
        vehicle launches.
        Thank-you line: Shopify reloads the page without ?build= after a
        successful post, so the build is kept in sessionStorage on submit
        and rgxRequestThanks() swaps the theme's generic success text for
        a vehicle-specific confirmation, then clears the key.
     ---------------------------------------------------------------- */
  var RGX_REQ_KEY = 'rgxVehicleRequest';
  // 2026-10-31: the form only takes vehicle requests. Old ?topic=unshipped|address|other
  // links (emails, bookmarks) open the chat instead (§2c); ?topic=install is redirected by
  // snippets/rgx-contact-fields.liquid.
  var RGX_TOPICS = {
    vehicle: 'Vehicle not listed'
  };
  var RGX_CHAT_TOPICS = { unshipped: 1, address: 1, other: 1, change: 1, refund: 1 };
  function rgxFillField(el, value) {
    if (!el) return;
    el.value = value;
    el.classList.add('has-content');
    var label = el.parentElement && el.parentElement.querySelector('label.floating-field');
    if (label) label.classList.add('hidden');
  }
  function rgxScrollToForm(form) {
    var target = form.closest('.contact-form') || form;
    setTimeout(function () {
      var header = document.querySelector('.shopify-section-header');
      var offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      window.scrollTo({ top: window.pageYOffset + target.getBoundingClientRect().top - offset - 12, behavior: 'smooth' });
    }, 80);
  }
  function rgxTopicParam() {
    var key;
    try { key = (new URLSearchParams(window.location.search).get('topic') || '').toLowerCase(); } catch (e) { return; }
    if (key && RGX_CHAT_TOPICS[key]) { rgxOpenChatSoon(); return; }
    if (!key || !RGX_TOPICS[key]) return;
    var form = document.querySelector('.contact-form__form');
    if (!form) return;
    var topic = form.querySelector('[data-rgx-topic]');
    if (topic && !topic.value) {
      topic.value = RGX_TOPICS[key];
      topic.dispatchEvent(new Event('change'));
    }
    rgxScrollToForm(form);
  }
  /* ----------------------------------------------------------------
     2c. Chat links (2026-10-31, Rachel). Any link whose href ends in
         "#chat" (we use /pages/contact#chat) opens the Shopify Inbox
         chat window (<shopify-chat>.show()) instead of navigating.
         If the chat widget is not on the page or not ready, the link
         just goes to the contact page, where WhatsApp is listed; that
         page then retries opening the chat for ~10 s.
     ---------------------------------------------------------------- */
  function rgxOpenChat() {
    var el = document.querySelector('shopify-chat');
    if (!el || typeof el.show !== 'function') return false;
    try { el.show(); return true; } catch (e) { return false; }
  }
  function rgxOpenChatSoon() {
    var tries = 0;
    (function attempt() { if (!rgxOpenChat() && ++tries < 20) setTimeout(attempt, 500); })();
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href$="#chat"]') : null;
    if (a && rgxOpenChat()) e.preventDefault();
  });
  if (window.location.hash === '#chat') rgxOpenChatSoon();

  function rgxPrefillContact() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var build = params.get('build');
    if (!build) return;
    build = build.replace(/\s+/g, ' ').trim().slice(0, 80);
    if (!build) return;
    var lights = (params.get('lights') || '').replace(/\s+/g, ' ').trim().slice(0, 30);
    var form = document.querySelector('.contact-form__form');
    if (!form) return;

    var topic = form.querySelector('[data-rgx-topic]');
    if (topic) {
      topic.value = 'Vehicle not listed';
      topic.dispatchEvent(new Event('change'));
    }
    var vehicle = form.querySelector('input[name="contact[Vehicle]"]');
    if (vehicle && !vehicle.value.trim()) rgxFillField(vehicle, build);
    var ta = form.querySelector('textarea');
    if (ta && !ta.value.trim()) {
      rgxFillField(ta, 'Vehicle request: ' + build +
        (lights ? '\nLooking for: ' + lights : '') +
        '\n\nPlease let me know when RIGNOX makes lights for my ' + build + '.');
    }

    // only the email is left: hide name/phone + message, make name optional
    var row = form.querySelector('.contact-form__flex');
    if (row) {
      var ins = row.querySelectorAll('input');
      for (var i = 0; i < ins.length; i++) {
        ins[i].required = false;
        ins[i].removeAttribute('aria-required');
      }
      row.style.display = 'none';
    }
    if (ta && ta.value.trim()) {
      var tf = ta.closest('.field');
      if (tf) tf.style.display = 'none';
    }
    var hint = form.querySelector('[data-rgx-hint="request"] p');
    if (hint) {
      hint.textContent = 'We don\u2019t make lights for your ' + build + ' yet. Your request is filled in \u2014 just add your email and send it. We log every request and use it to plan new fitments, and we\u2019ll email you as soon as lights for your vehicle launch.';
    }

    form.addEventListener('submit', function () {
      try { sessionStorage.setItem(RGX_REQ_KEY, (vehicle && vehicle.value.trim()) || build); } catch (e) {}
    });

    rgxScrollToForm(form);
  }
  function rgxRequestThanks() {
    var stored = null;
    try { stored = sessionStorage.getItem(RGX_REQ_KEY); } catch (e) { return; }
    if (!stored) return;
    var done = document.querySelector('.contact-form__form .form-status');
    if (!done) return;
    try { sessionStorage.removeItem(RGX_REQ_KEY); } catch (e) {}
    var icon = done.querySelector('svg');
    done.textContent = '';
    if (icon) done.appendChild(icon);
    done.appendChild(document.createTextNode(' Thanks \u2014 your ' + stored + ' is on our list. We log every request and use it to plan new fitments, and we\u2019ll email you as soon as lights for your vehicle launch.'));
  }
  function rgxContactPage() {
    rgxPrefillContact();
    rgxTopicParam();
    rgxRequestThanks();
  }
  if (window.location.pathname.indexOf('/pages/contact') !== -1) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rgxContactPage);
    } else {
      rgxContactPage();
    }
  }

  /* ----------------------------------------------------------------
     3. Product page phones/tablets: keep the section tab bar visible
        while pinned. main-product.js toggles .is-fixed on .sticky-tabs
        (position: fixed) at every width, but on phones the bar rode
        underneath the fixed header (the product section is a z-index:2
        stacking context, so the bar's own z-index can't beat the header).
        While .is-fixed is on we move the node to <body> (out of that
        context) and publish the header stack's bottom edge as
        --rgx-tabs-top for rgx-overrides.css §26; when it comes off we
        put the node back exactly where it was. The node is MOVED, not
        cloned — the theme's lava-lamp blob and tab handlers stay bound.
        Desktop (>989px) is untouched.

        headerBottom(): the pinned stack is the sticky header PLUS, on
        phones, the sticky announcement bar sitting above it (§4/§28).
        They are sibling sections in <body>, so we measure BOTH
        .shopify-section-header and .section-announcement and take the
        lowest bottom. The header now stops at top:var(--rgx-anno-h)
        (not 0), so the old `top <= 1` test missed it — widened to
        `top < 160` (any element parked in the top band).
     ---------------------------------------------------------------- */
  function rgxTabsPinner() {
    var tabs = document.querySelector('.product__info-navigations--wrapper.sticky-tabs');
    if (!tabs || tabs.rgxPinnerInit) return;
    tabs.rgxPinnerInit = true;

    var mq = window.matchMedia('(max-width: 989px)');
    var home = document.createComment('rgx-tabs-home');
    tabs.parentNode.insertBefore(home, tabs);

    function headerBottom() {
      var sels = ['.shopify-section-header', '.section-announcement'];
      var bottom = 0;
      for (var s = 0; s < sels.length; s++) {
        var els = document.querySelectorAll(sels[s]);
        for (var i = 0; i < els.length; i++) {
          var cs = window.getComputedStyle(els[i]);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
          var r = els[i].getBoundingClientRect();
          if (r.height > 0 && r.top < 160 && r.bottom > bottom) bottom = r.bottom;
        }
      }
      return Math.max(0, Math.round(bottom));
    }

    function sync() {
      var fixed = tabs.classList.contains('is-fixed');
      if (mq.matches && fixed) {
        document.documentElement.style.setProperty('--rgx-tabs-top', headerBottom() + 'px');
        if (tabs.parentNode !== document.body) document.body.appendChild(tabs);
      } else if (tabs.parentNode === document.body && home.parentNode) {
        home.parentNode.insertBefore(tabs, home.nextSibling);
      }
    }

    new MutationObserver(sync).observe(tabs, { attributes: true, attributeFilter: ['class'] });
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
    window.addEventListener('scroll', function () {
      if (mq.matches && tabs.classList.contains('is-fixed')) {
        document.documentElement.style.setProperty('--rgx-tabs-top', headerBottom() + 'px');
      }
    }, { passive: true });
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rgxTabsPinner);
  } else {
    rgxTabsPinner();
  }
  document.addEventListener('shopify:section:load', rgxTabsPinner);

  /* ----------------------------------------------------------------
     4. Phones: publish the announcement bar's height so the sticky
        header can drop below it. header-group renders .section-announcement
        and .shopify-section-header as SIBLINGS in <body>; the theme only
        makes the header sticky (top:0) and lets the bar scroll away.
        rgx-overrides.css §28 makes the bar sticky (top:0) on phones and
        offsets the header's top by --rgx-anno-h so the two stack instead
        of overlapping. The bar's height is not fixed (promo text can
        wrap), so measure it live here. Desktop publishes 0 so the header
        keeps its own top:0. Re-measures on resize and orientation.
     ---------------------------------------------------------------- */
  function rgxAnnoHeight() {
    var anno = document.querySelector('.section-announcement');
    if (!anno) {
      document.documentElement.style.setProperty('--rgx-anno-h', '0px');
      return;
    }
    var mq = window.matchMedia('(max-width: 749px)');
    function set() {
      var h = mq.matches ? Math.round(anno.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--rgx-anno-h', h + 'px');
    }
    set();
    if (anno.rgxAnnoInit) return;
    anno.rgxAnnoInit = true;
    if (window.ResizeObserver) new ResizeObserver(set).observe(anno);
    window.addEventListener('resize', set, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', set); else if (mq.addListener) mq.addListener(set);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rgxAnnoHeight);
  } else {
    rgxAnnoHeight();
  }
  document.addEventListener('shopify:section:load', rgxAnnoHeight);

  /* ----------------------------------------------------------------
     5. Compatibility block: flag the exclusion line so it cannot be
        skim-read as just another spec row. The block is authored in
        each product's description as <div class="rgx-pdp"> with plain
        <p><strong>Label:</strong> value</p> rows — ~45 SKUs carry a
        "Does not fit:" row and only one of them had a class on it, so
        we tag them at runtime instead of hand-editing 45 descriptions.
        Styles: rgx-overrides.css §22.

        The same markup renders TWICE on a product page — once inside
        the long description and once inside the Fitment Check modal
        (snippets/rgx_compatibility.liquid copies the block's inner
        HTML into .rgx-fitment__content), so both roots are scanned.
        The modal's content is in the DOM from first paint, so no
        observer is needed.

        Matching is prefix-based on the <strong> text, lowercased with
        any trailing colon dropped: it must catch "Does not fit:",
        the qualified "Does not fit — Dual Projector build:", and the
        legacy "Not Fits:" wording. classList.add is idempotent, so the
        one product already carrying .rgx-alert is unaffected.
     ---------------------------------------------------------------- */
  function rgxFlagExclusions() {
    var rows = document.querySelectorAll('.rgx-pdp > p, .rgx-fitment__content > p');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('strong');
      if (!label) continue;
      var text = label.textContent.replace(/[:：]\s*$/, '').trim().toLowerCase();
      if (text.indexOf('does not fit') === 0 || text.indexOf('not fits') === 0) {
        rows[i].classList.add('rgx-alert');
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rgxFlagExclusions);
  } else {
    rgxFlagExclusions();
  }
  document.addEventListener('shopify:section:load', rgxFlagExclusions);

  /* ----------------------------------------------------------------
     6. Cart drawer: free G09 PRO nudge add buttons (2026-09-22).
        Markup: snippets/rgx-g09-nudge.liquid (rendered inside the
        drawer). Every state of the nudge is decided in Liquid because
        Force repaints the whole drawer from ?sections=cart-drawer on
        each cart change; this script only turns a click on
        [data-rgx-g09-add] (JSON array of {id, quantity}) into the same
        request assets/product-form.js makes — POST routes.cart_add_url
        with items[] + sections=cart-drawer,cart-icon-bubble — then
        hands the response to cart-drawer.renderContents(), which
        repaints the drawer (and with it this nudge) and keeps it open.
        Delegated on document because the button node is replaced on
        every repaint.
     ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-rgx-g09-add]') : null;
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    var items;
    try { items = JSON.parse(btn.getAttribute('data-rgx-g09-add')); } catch (err) { return; }
    if (!items || !items.length) return;

    var cart = document.querySelector('cart-drawer');
    var fd = new FormData();
    for (var i = 0; i < items.length; i++) {
      fd.append('items[' + i + '][id]', items[i].id);
      fd.append('items[' + i + '][quantity]', items[i].quantity || 1);
    }
    if (cart) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    var lbl = btn.querySelector('.rgx-g09__btn-label');
    var busy = btn.querySelector('.rgx-g09__btn-busy');
    if (lbl) lbl.hidden = true;
    if (busy) busy.hidden = false;

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          // Shopify returned an error (e.g. sold out) — put the button back
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (lbl) lbl.hidden = false;
          if (busy) busy.hidden = true;
          if (window.console) console.warn('rgx-g09 add failed:', res.description || res.message);
          return;
        }
        if (cart && res.sections) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rgx-g09-nudge', productVariantId: items[0].id });
          }
          cart.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('loading');
        if (lbl) lbl.hidden = false;
        if (busy) busy.hidden = true;
        if (window.console) console.error(err);
      });
  });

  /* ----------------------------------------------------------------
     7. Contact form topic (2026-10-06; simplified 2026-11-05). Markup:
        snippets/rgx-contact-fields.liquid, rendered inside
        sections/contact-form.liquid. The visually hidden
        <select name="contact[Topic]" data-rgx-topic> holds the topic
        (today one option, "Vehicle not listed", selected by default;
        ?topic= / ?build= links prefill it via §2). sync() applies the
        option's data-need, a space-separated list of extra fields to
        show + require:
          "order"   -> Order number   (not shipped yet, address change)
          "vehicle" -> Vehicle        (vehicle not listed)
          "order vehicle"             (installation help)
        and data-hint picks the one-line hint ([data-rgx-hint]).
        If a prefill left the select empty, submit falls back to the
        first option instead of blocking with no visible message.
        Hidden fields are not required, so the browser never blocks a
        submit on a field the buyer cannot see. Uses style.display (not
        the hidden attribute) because the theme's .field / add-text
        classes set their own display. Runs after §2.
        (The topic tap buttons and their "Please pick" error were
        removed from the markup earlier; their code went 2026-11-05.)
     ---------------------------------------------------------------- */
  function rgxContactTopics() {
    var forms = document.querySelectorAll('.contact-form__form');
    for (var f = 0; f < forms.length; f++) {
      (function (form) {
        var sel = form.querySelector('[data-rgx-topic]');
        if (!sel || sel.rgxInit) return;
        sel.rgxInit = true;
        var needs = form.querySelectorAll('[data-rgx-need]');
        var hints = form.querySelectorAll('[data-rgx-hint]');
        function sync() {
          var opt = sel.options[sel.selectedIndex];
          var need = ' ' + ((opt && opt.getAttribute('data-need')) || '') + ' ';
          var hint = opt ? opt.getAttribute('data-hint') : null;
          for (var i = 0; i < needs.length; i++) {
            var on = need.indexOf(' ' + needs[i].getAttribute('data-rgx-need') + ' ') !== -1;
            needs[i].style.display = on ? '' : 'none';
            var input = needs[i].querySelector('input');
            if (input) {
              input.required = on;
              if (on) input.setAttribute('aria-required', 'true'); else input.removeAttribute('aria-required');
            }
          }
          for (var j = 0; j < hints.length; j++) {
            var show = hints[j].getAttribute('data-rgx-hint') === hint;
            hints[j].hidden = !show;
            hints[j].style.display = show ? '' : 'none';
          }
        }
        form.addEventListener('submit', function () {
          if (!sel.value && sel.options.length) { sel.selectedIndex = 0; sync(); }
        });
        sel.addEventListener('change', sync);
        sync();
      })(forms[f]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rgxContactTopics);
  } else {
    rgxContactTopics();
  }
  document.addEventListener('shopify:section:load', rgxContactTopics);

  /* ----------------------------------------------------------------
     8. Per-SKU spec table (P2 2026-10-15, Rachel).
        snippets/rignox-spec-fixed renders one .rgx-spec-variant per
        variant (data-rgx-spec-variant="<variant id>") when the product
        has custom.spec_* variant fields; only the SKU the page loaded
        with is visible. The theme publishes PUB_SUB_EVENTS.variantChange
        ({data: {sectionId, variant}}) after a variant switch; show the
        matching table. Products without variant fields have no
        .rgx-spec-variant and are untouched. CSS: rgx-overrides.css §36.
     ---------------------------------------------------------------- */
  function rgxSpecShow(id) {
    if (!id) return;
    var boxes = document.querySelectorAll('[data-rgx-spec-variant]');
    if (!boxes.length) return;
    var hit = false;
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].getAttribute('data-rgx-spec-variant') === String(id)) hit = true;
    }
    if (!hit) return;
    for (var j = 0; j < boxes.length; j++) {
      boxes[j].hidden = boxes[j].getAttribute('data-rgx-spec-variant') !== String(id);
    }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      rgxSpecShow(e && e.data && e.data.variant && e.data.variant.id);
    });
  }
})();
